import script from "./BusinessPermit.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessPermit.vue?vue&type=script&setup=true&lang=js"

import "./BusinessPermit.vue?vue&type=style&index=0&id=0b2a38a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2a38a9"]])

export default __exports__